import { useAppSelector } from '../../../hooks/storeHooks'
import { selectStoreById } from '../selectors/selectors'

export const useCurrentStore = () => {
  const currentStoreId = useAppSelector((state) => state.mainStoreId)
  const currentStore = useAppSelector((state) => selectStoreById(state, currentStoreId))

  return { currentStoreId, currentStore }
}
